import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
// import Footer from "../../layout/Footer/Footer";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
  Spinner,
  Form,
} from "reactstrap";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { encode } from "base64-arraybuffer";
import axios from "axios";
import BajaMultiple from "../../BajaMultiple";
import StatusMultiple from "../../StatusMultiple";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import CurrencyInput from "react-currency-input-field";
import { formatValue } from "react-currency-input-field";
import moment from "moment";

import { v4 as uuidv4 } from "uuid";
import AutorizadoMultiple from "../../AutorizadoMultiple";
import DividirPrepedidoModal from "./DividirPrepedidoModal";
import EditarArticulosPedido from "./EditarArticulosPedido";
import FotosPedidoModal from "./FotosPedidoModal";
import DetalleDivididoModal from "./DetalleDivididoModal";
import ImportarArticulosModal from "../../../ImportarArticulosModal";
import ImportarPrepedidoModal from "../../../ImportarPrepedidoModal";
import { folioVendedor } from "../../../folioVendedor";
import SurtirPedidoModal from "../../../SurtirPedidoModal";
import MenuDescargas from "../../../MenuDescargas";
import { descargaPorTallaColor } from "../../../descargaVariantes";
import { desglosePedido } from "../../../desglosePedido";
import { exportaExcelConFotoOpcional } from "../../../excelConFotos";

function ListadoPedidos() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_ARTICULOS = process.env.REACT_APP_URL_ARTICULOS;
  const URL_COLABORADORES = process.env.REACT_APP_URL_COLABORADORES;
  const URL_PEDIDOS = process.env.REACT_APP_URL_PEDIDOS;
  const URL_ARTICULOS_PEDIDO = process.env.REACT_APP_URL_ARTICULOS_PEDIDO;
  const URL_CLIENTES = process.env.REACT_APP_URL_CLIENTES;
  const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;
  const PASSWORD_CAMBIA_PRECIO = process.env.REACT_APP_PASSWORD_CAMBIA_PRECIO;
  const URL_INVENTARIOS = process.env.REACT_APP_URL_INVENTARIOS;
  const URL_ARTICULOS_PROPORCION = process.env.REACT_APP_URL_ARTICULOS_PROPORCION;
  const URL_COLORES = process.env.REACT_APP_URL_COLORES;

  let hoy = new Date();
  let inicio = new Date();
  inicio.setDate(inicio.getDate() - 122);

  let endDate = moment(hoy).format("YYYY-MM-DD");
  let startDate = moment(inicio).format("YYYY-MM-DD");

  const [articulos, setArticulos] = useState([]);

  const [clientes, setClientes] = useState([]);
  const [selectedCliente, setSelectedCliente] = useState("");
  const [colaboradores, setColaboradores] = useState([]);
  const [selectedColaborador, setSelectedColaborador] = useState("");

  const [selectedFechaInicio, setSelectedFechaInicio] = useState(startDate);
  const [selectedFechaFin, setSelectedFechaFin] = useState(endDate);

  const [fecha, setFecha] = useState("");
  // el cliente le llama "orden de compra" a lo que aqui es el pedido
  const [total_general, setTotalGeneral] = useState(0);
  const [numero_pedido, setNumeroPedido] = useState("");

  const [idEdit, setIdEdit] = useState("");
  const [selectedClienteEdit] = useState("");
  const [selectedColaboradorEdit] = useState("");
  const [comisionTDC, setComisionTDC] = useState(0);
  const [comisionFlete, setComisionFlete] = useState(0);
  const [selectedImpuesto, setSelectedImpuesto] = useState(0);
  const [iva, setIva] = useState(0);
  const [subTotal, setSubTotal] = useState(0);
  const [surtido, setSurtido] = useState("");
  const [nombreClienteEdit, setNombreClienteEdit] = useState("");
  const [idClienteEdit, setIdClienteEdit] = useState("");
  const [fechaModificado, setFechaModificado] = useState("");

  const [articulosPedido, setArticulosPedido] = useState([]);
  const [total_general_edit, setTotalGeneralEdit] = useState(0);
  const [total_cantidad_edit, setTotalCantidadEdit] = useState(0);
    const [descuento, setDescuento] = useState(0);
    const [descuentoNumero, setDescuentoNumero] = useState(0);

  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);
  const [validaBoton, setValidaBoton] = useState(true);

  const [inputFields, setInputFields] = useState([
    {
      id: uuidv4(),
      colores: "",
      tallas: "",
      articulos: "",
      piezasPorCaja: 0,
      cajas: 0,
      cantidad: 0,
      precio: 0,
      total: 0,
    },
  ]);
  const [coloresCat, setColoresCat] = useState([]);
  const [tallasCat, setTallasCat] = useState([]);

  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [mailTo, setMailTo] = useState("");


  const [modalNoDisponible, setModalNoDisponible] = useState(false);
  const toggleNoDisponible = () => setModalNoDisponible(!modalNoDisponible);
  const [allArticulosAutorizar, setAllArticulosAutorizar] = useState([]);

  const [inventarios, setInventarios] = useState([]);

  const [status, setStatus] = useState("Abierto");
  const [autorizadoApartado, setAutorizadoApartado] = useState("");
  const [tipoFiltro, setTipoFiltro] = useState("");
  // Dividir prepedido en varios pedidos
  const [modalDividir, setModalDividir] = useState(false);
  // Alta masiva de modelos desde un layout de Excel
  const [modalImportar, setModalImportar] = useState(false);
  const [modalPrepedido, setModalPrepedido] = useState(false);
  // se surte desde aqui mismo, sin ir a otra pantalla
  const [modalSurtir, setModalSurtir] = useState(false);
  const [pedidoSurtir, setPedidoSurtir] = useState(null);
  const [prepedidoDividir, setPrepedidoDividir] = useState(null);
  const [autorizadoSurtido, setAutorizadoSurtido] = useState("");

  const [cambiarPrecio, setCambiarPrecio] = useState(false);
  const [modalCambiaPrecio, setModalCambiaPrecio] = useState(false);
  const toggleCambiaPrecio = () => setModalCambiaPrecio(!modalCambiaPrecio);
  const [password, setPassword] = useState("");

  //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const [AbrirEditar, setAbrirEditar] = useState(false);
  // pedido cuyos articulos se editan (misma captura que PedidosCreate)
  const [pedidoEditar, setPedidoEditar] = useState(null);
  // fotos de los modelos del pedido (una por renglon)
  const [pedidoFotos, setPedidoFotos] = useState(null);
  // prepedido dividido cuyo detalle se esta viendo
  const [prepedidoDetalle, setPrepedidoDetalle] = useState(null);

  const ITEMS_PER_PAGE = 50;

  useMemo(() => {
    axios
      .get(`${URL_PEDIDOS}Fechas/${selectedFechaInicio}/${selectedFechaFin}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allPedidos = response.data;

        if (user.vendedor === "Si") {
          allPedidos = allPedidos.filter(pedido => pedido.colaboradores?.[0]?.email === user.email);
        }
        // console.log("hola", allPedidos)
        // Array para pagination
        let arrayTabla = allPedidos
          .sort((a, b) => (parseFloat(a.idPedido) < parseFloat(b.idPedido) ? 1 : -1))
          .map((a) => {
            return {
              _id: a._id,
              numero: a.idPedido,
              activo: a.is_active,
              fecha: a.fecha,
              colaboradores:
                a.colaboradores?.[0]?.nombre + " " + a.colaboradores?.[0]?.apellido,
              idColaboradores: a.colaboradores?.[0]?._id,
              consecutivoVendedor: a.consecutivoVendedor || "",
              folioVendedor: folioVendedor(`${a.colaboradores?.[0]?.nombre || ""} ${a.colaboradores?.[0]?.apellido || ""}`, a.consecutivoVendedor, a.divisionNumero),
              idOrigen: a.prepedidoOrigen?.[0] || "",
              observaciones: a.observaciones,
              ordenCompraCliente: a.ordenCompraCliente || "",
              prepedidoCliente: a.prepedidoCliente || "",
              subTotal: a.subTotal,
              iva: a.iva,
              total_general: a.total_general,
              clientes: a.clientes?.[0]?.nombre_comercial,
              idClientes: a.clientes?.[0]?._id,
              total_cantidad: a.total_cantidad,
              status: a.status,
              tipo: a.tipo || "Pedido",
              autorizadoPrepedido: a.autorizadoPrepedido || "Si",
              autorizadoApartado: a.autorizadoApartado,
              autorizadoSurtido: a.autorizadoSurtido,
              comisionTDC: a.comisionTDC,
              comisionFlete: a.comisionFlete,
              impuestos: a.impuestos,
              descuento: a.descuento,
              paqueteria: a.paqueteria,
              surtido: a.surtido,
              codigoClientes: a.clientes?.[0]?.codigo,
              calle: a.clientes?.[0]?.calle,
              numero_ext: a.clientes?.[0]?.numero_ext,
              numero_int: a.clientes?.[0]?.numero_int,
              pais: a.clientes?.[0]?.pais,
              estado: a.clientes?.[0]?.estado,
              ciudad: a.clientes?.[0]?.ciudad,
              delegacion: a.clientes?.[0]?.delegacion,
              colonia: a.clientes?.[0]?.colonia,
              cp: a.clientes?.[0]?.cp,
              RFC: a.clientes?.[0]?.RFC,
              fechaModificado: a.fechaModificado,
              telefono: a.clientes?.[0]?.telefono,
              editado: a.editado,
              editPedido: a.editPedido,
              autorizoApartado: a.autorizoApartado,
              autorizoSurtido: a.autorizoSurtido,
              fechaInicio: a.fechaInicio,
              fechaCancelacion: a.fechaCancelacion,
              piezasEntregadas: a.piezasEntregadas,
              piezasPendientes: a.total_cantidad - a.piezasEntregadas,
            };
          })
          .filter(function (el) {
            return el != null;
          });

        let data = Object.values(arrayTabla);
        setComments(data);
        //
      })
      .catch((err) => {
        console.log(err);
      });

 
  }, [user, selectedFechaInicio, selectedFechaFin]);

  useEffect(() => {
    axios
    .get(`${URL_CLIENTES}GeneralActivos`, {
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    })
    .then((response) => {
      let allClientes = response.data;
      setClientes(allClientes);
    })
    .catch((err) => {
      console.log(err);
    });

  axios
    .get(URL_COLABORADORES, {
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    })
    .then((response) => {
      let allColaboradores = response.data;
      setColaboradores(allColaboradores);
    })
    .catch((err) => {
      console.log(err);
    });

  axios
    .get(`${URL_ARTICULOS}Activos`, {
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    })
    .then((response) => {
      let allArticulos = response.data;
      setArticulos(allArticulos);
    })
    .catch((err) => {
      console.log(err);
    });

  axios
    .get(`${URL_INVENTARIOS}Disponible`, {
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    })
    .then((response) => {
      let allDisponible = response.data;
      setInventarios(allDisponible);
    })
    .catch((err) => {
      console.log(err);
    });
  }, []);

function PDFTabla() {
  const data = comments.map((a) => {
    if (
      (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
      (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
      (status == 0 || status == a.status) &&
      (autorizadoApartado == 0 ||
        autorizadoApartado == a.autorizadoApartado) &&
      (autorizadoSurtido == 0 || autorizadoSurtido == a.autorizadoSurtido) &&
      (selectedCliente == 0 || selectedCliente == a.idClientes) &&
      (selectedColaborador == 0 || selectedColaborador == a.idColaboradores)
    ) {

      const cantidad = a.activo === "No"
        ? "Cancelado"
        : a.total_cantidad;

      const total = a.activo === "No"
        ? "Cancelado"
        : new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            maximumFractionDigits: 2,
          }).format(a.total_general);

      return [
        a.numero,
        a.fecha,
        a.colaboradores,
        a.clientes,
        cantidad,
        total,
      ];
    }
  });

  const dataPDF = Object.values(data);
  const dataPDFLimpia = dataPDF.filter(function (el) {
    return el != null;
  });

  const doc = new jsPDF("landscape", "mm", "a4", true);

  var img = new Image();
  var img2 = new Image();
  img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";

  doc.addImage(img2, "png", 120, 10, 30, 30);

  doc.text(`Listado Pedidos`, 20, 30);
  doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);

  doc.autoTable({
    head: [["Numero", "Fecha", "Vendedor", "Cliente", "Cantidad", "Total"]],
    body: dataPDFLimpia,
    headStyles: {
      fillColor: ["#0dd237"],
      lineWidth: 0,
    },
    footStyles: {
      fillColor: ["#0dd237"],
    },
    theme: "grid",
    startY: 45,
  });

  doc.save(`Pedidos.pdf`);
}

  function excel() {
    const dataExcel = comments.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (status == 0 || status == a.status) &&
        (autorizadoApartado == 0 ||
          autorizadoApartado == a.autorizadoApartado) &&
        (autorizadoSurtido == 0 || autorizadoSurtido == a.autorizadoSurtido) &&
        (selectedCliente == 0 || selectedCliente == a.idClientes) &&
        (selectedColaborador == 0 || selectedColaborador == a.idColaboradores)
      ) {
        return {
          Numero: a.numero,
          Fecha: a.fecha,
          Cliente: a.clientes,
          Vendedor: a.colaboradores,
          Piezas: a.total_cantidad,
          PiezasSurtidas: a.piezasEntregadas,
          PiezasPendientes: a.piezasPendientes,
          Total: a.total_general,
        };
      }
    });
    const dataExportExcel = Object.values(dataExcel);
    const dataExcelLimpia = dataExportExcel.filter(function (el) {
      return el != null;
    });

    var option = {};

    option.fileName = "ListadoPedidos";

    option.datas = [
      {
        sheetData: dataExcelLimpia,
        sheetName: "ListadoPedidos",
        sheetFilter: [
          "Numero",
          "Fecha",
          "Cliente",
          "Vendedor",
          "Piezas",
          "PiezasSurtidas",
          "PiezasPendientes",
          "Total",
        ],
        sheetHeader: [
           "Numero",
          "Fecha",
          "Cliente",
          "Vendedor",
          "Piezas",
          "PiezasSurtidas",
          "PiezasPendientes",
          "Total",
        ],
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  function enviaMail() {
    const data = comments.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (status == 0 || status == a.status) &&
        (autorizadoApartado == 0 ||
          autorizadoApartado == a.autorizadoApartado) &&
        (autorizadoSurtido == 0 || autorizadoSurtido == a.autorizadoSurtido) &&
        (selectedCliente == 0 || selectedCliente == a.idClientes) &&
        (selectedColaborador == 0 || selectedColaborador == a.idColaboradores)
      ) {
        return [
          a.numero,
          a.fecha,
          a.colaboradores,
          a.clientes,
          a.total_cantidad,
          new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            maximumFractionDigits: 2,
          }).format(a.total_general),
        ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape", "mm", "a4", true);
    var img = new Image();

    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 120, 10, 30, 30);
    doc.text(`Listado PO`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [["Numero", "Fecha", "Vendedor", "Cliente", "Cantidad", "Total"]],
      body: dataPDFLimpia,
      headStyles: {
        fillColor: ["#0dd237"],
        lineWidth: 0,
      },
      footStyles: {
        fillColor: ["#0dd237"],
      },
      theme: "grid",
      startY: 45,
    });
    var att = doc.output("arraybuffer");
    var base64File = encode(att);

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Listado Pedidos",
          email: mailTo,
          fileName: "ListadoPedidos.pdf",
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras el listado de Pedidos.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
         
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail();
        Swal.fire("Good job!", "Enviado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  async function PDFOC(
    fecha,
    colaboradores,
    idClientes,
    clientes,
    total_cantidad,
    total_general,
    observaciones,
    numero,
    impuestos,
    descuento,
    comisionFlete,
    comisionTDC,
    idPDFOC,
    calle,
    numero_ext,
    numero_int,
    pais,
    estado,
    ciudad,
    delegacion,
    colonia,
    cp,
    RFC,
    paqueteria,
    codigoClientes,
    autorizadoApartado,
    autorizadoSurtido,
    telefono,
    editado,
    editPedido,
    autorizoApartado,
    autorizoSurtido,
    subtotal,
    iva
  ) {
    // Un renglon por modelo (articulo + renglon del pedido) con sus colores y
    // tallas; las fotos se bajan antes de dibujar (antes iba con setTimeout y
    // sin esperar, y la foto no salia).
    let modelos;
    try {
      Swal.fire({ title: "Armando el PDF", html: "Bajando las fotos...", allowOutsideClick: false, onBeforeOpen: () => Swal.showLoading() });
      modelos = await desglosePedido(idPDFOC, { conFoto: true });
      Swal.close();
    } catch (err) {
      Swal.close();
      Swal.fire({ icon: "error", title: "No se pudo armar el PDF", text: err.message });
      return;
    }
    if (!modelos.length) {
      Swal.fire({ icon: "info", title: "Sin articulos", text: "Este pedido no tiene articulos." });
      return;
    }
        const TK = modelos.reduce((s, m) => s + m.piezas, 0);
        const fmt = (n) => new Intl.NumberFormat("en-US").format(Number(n) || 0);
        const dinero = (n) => new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(Number(n) || 0);
          const dataPDFLimpia = modelos.map((m) => [
            "",
            `${m.codigo} ${m.nombre}${m.repetido ? `\n(renglon ${m.renglon})` : ""}`,
            m.colColores + (m.colores.length > 1 ? `\n(${m.proporcionColores})` : ""),
            m.colTallas + (m.tallas.length > 1 ? `\n(${m.proporcionTallas})` : ""),
            fmt(m.piezas),
            fmt(m.surtido),
            fmt(m.pendiente),
            dinero(m.precio),
            dinero(m.total),
          ]);

          const columnStyles = {
            0: { cellWidth: 22, minCellHeight: 22 },
            1: { cellWidth: 38 },
            2: { cellWidth: 36 },
            3: { cellWidth: 26 },
            4: { halign: "right" },
            5: { halign: "right" },
            6: { halign: "right" },
            7: { halign: "right" },
            8: { halign: "right" },
          };

          const doc = new jsPDF({ compressPdf: true });
          // el logo tiene que estar cargado antes de addImage (antes lo cubria el setTimeout)
          const img = await new Promise((resolve) => {
            const i = new Image();
            i.onload = () => resolve(i);
            i.onerror = () => resolve(null);
            i.src = process.env.PUBLIC_URL + "logoInstitucion.png";
          });
          const backgroundColor = ["#d1d2d4"];
          const backgroundColorBoxLightGray = ["#e6e7e9"];
          const backgroundColorBoxBlack = ["#231f20"];
          const backgroundColorBoxPurple = ["#0dd237"];
          const margins = { left: 5, right: 5 };

          if (img) doc.addImage(img, "png", 15, 5, 33, 33);

          // img.src = process.env.PUBLIC_URL + "marcas.png";
          // doc.addImage(img, "png", 9, 28, 192, 10);
          // doc.setFontSize(10);

          doc.setFillColor(...backgroundColor);
          doc.rect(5, 40, 200, 6, "F");
          doc.setTextColor("#000000");
          doc.setFontSize(10);
          doc.text(`Pedido ${numero}`, 8, 44);

          doc.setTextColor("#000000");

          doc.text(`Cliente: ${codigoClientes} - ${clientes} Telefono: ${telefono}`, 8, 52);
          doc.text(
            `Direccion: ${calle} ${numero_ext} ${numero_int} ${estado} ${ciudad} ${cp}`,
            8,
            57
          );
          doc.text(`Vendedor: ${colaboradores}`, 8, 62);      
          doc.setFontSize(12);
          doc.setFont("helvetica", "bold");
          doc.text(`Este es el Pedido numero ${numero}, no es una nota`, 110, 52);

          // doc.setTextColor("#0dd237");
          // doc.setFontSize(12);
          // doc.setFont("helvetica", "bold");
          // doc.text(`cavannaImportacion.mx`, 175, 44);
          // doc.setTextColor("#000000");

          doc.setFontSize(14);
          doc.setFillColor(...backgroundColorBoxBlack);
          doc.rect(100, 4, 105, 22, "F");
          doc.setFillColor(...backgroundColorBoxPurple);
          doc.rect(74, 4, 25, 22, "F");
          doc.setTextColor("#ffffff");
          doc.text(`PEDIDO`, 125, 12);
          doc.setFont("helvetica", "normal");
          doc.text(`México, D. F. a ${fecha}`, 125, 22);

          doc.autoTable({
            head: [["", "MODELO", "COLORES", "TALLAS", "CANTIDAD", "SURTIDO", "POR SURTIR", "PRECIO", "IMPORTE"]],
            body: dataPDFLimpia,
            styles: { fontSize: 8, cellPadding: 1.5, valign: "middle", textColor: ["#000000"] },
            headStyles: {
              fillColor: ["#0dd237"],
              lineWidth: 0,
              halign: "center",
              valign: "middle",
              fontSize: 8,
            },
            footStyles: {
              fillColor: ["#0dd237"],
            },
            columnStyles: columnStyles,
            theme: "grid",
            margin: { left: 5, right: 5 },
            startY: 70,

            // la foto del modelo en la primera columna (ya viene como dataURL)
            didDrawCell: function (data) {
              if (data.column.index !== 0 || data.cell.section !== "body") return;
              const m = modelos[data.row.index];
              if (!m || !m.foto) return;
              const lado = Math.min(data.cell.width, data.cell.height) - 2;
              try {
                doc.addImage(m.foto, data.cell.x + 1, data.cell.y + 1, lado, lado);
              } catch (e) { /* si la foto no se pudo leer, el renglon va sin ella */ }
            },

            showFoot: "lastPage",
          });

          let finalY = doc.autoTable.previous.finalY;
const pageHeight = doc.internal.pageSize.height;
const espacioNecesario = 120;

if (finalY + espacioNecesario > pageHeight) {
  doc.addPage();
  finalY = 10;
}

          doc.setFillColor(...backgroundColorBoxPurple);
          doc.rect(5, finalY + 1, 36, 6, "F");
          doc.setTextColor("#ffffff");
          doc.setFontSize(8);
          doc.text(`TOTAL DE ARTICULOS`, 7, finalY + 5);
          doc.setTextColor("#000000");
          // doc.text(
          //   `________________________________________________________________________________________________________________________________`,
          //   5,
          //   finalY + 30
          // );

          doc.setFillColor(...backgroundColorBoxLightGray);
          doc.setFont("helvetica", "normal");
          doc.rect(40, finalY + 1, 40, 6, "F");
          doc.text(
            new Intl.NumberFormat("en-US").format(TK) + " Piezas",
            42,
            finalY + 5
          );

          doc.setFontSize(7.5);
          doc.text(
            `1. Esta es una venta en firme y no se acepta ningún tipo de descuento o devolución sin consentimiento previo.`,
            5,
            finalY + 11
          );
          doc.text(
            `2. La mercancía viaja por cuenta y riesgo del cliente, no somos responsables por faltante.`,
            5,
            finalY + 14
          );
          doc.text(
            `3. El pago de la mercancía debe realizarse en tiempo y forma pactados a la cuenta proporcionada por nosotros.`,
            5,
            finalY + 17
          );

          doc.setFillColor(...backgroundColorBoxPurple);
          doc.rect(144, finalY + 1, 37, 6, "F");
          doc.setTextColor("#ffffff");
          doc.setFont("helvetica", "bold");
          doc.setFontSize(8);
          doc.text(`SUBTOTAL $`, 153, finalY + 5);

          doc.setFillColor(...backgroundColorBoxLightGray);
          doc.setTextColor("#000000");
          doc.setFont("helvetica", "normal");
          doc.rect(181, finalY + 1, 24, 6, "F");
          doc.text(
            new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
              maximumFractionDigits: 2,
            }).format(Number(subtotal) || 0),
            183,
            finalY + 5
          );

          doc.setFillColor(...backgroundColorBoxPurple);
          doc.rect(144, finalY + 8, 37, 6, "F");
          doc.setTextColor("#ffffff");
          doc.setFont("helvetica", "bold");
          doc.setFontSize(8);
          doc.text(`FLETE $`, 153, finalY + 12);

          doc.setFillColor(...backgroundColorBoxLightGray);
          doc.setTextColor("#000000");
          doc.setFont("helvetica", "normal");
          doc.rect(181, finalY + 8, 24, 6, "F");
          doc.text(
            new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
            }).format(comisionFlete),
            183,
            finalY + 12
          );

          doc.setFillColor(...backgroundColorBoxPurple);
          doc.rect(144, finalY + 15, 37, 6, "F");
          doc.setTextColor("#ffffff");
          doc.setFont("helvetica", "bold");
          doc.setFontSize(8);
          doc.text(
            `DESCUENTO ${descuento}%`,
            153,
            finalY + 19
          );

          doc.setFillColor(...backgroundColorBoxLightGray);
          doc.setTextColor("#000000");
          doc.setFont("helvetica", "normal");
          doc.rect(181, finalY + 15, 24, 6, "F");
          doc.text(
            new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
              maximumFractionDigits: 2,
            }).format(((Number(subtotal) || 0) * (Number(descuento) || 0)) / 100),
            183,
            finalY + 19
          );

          doc.setFillColor(...backgroundColorBoxPurple);
          doc.rect(144, finalY + 22, 37, 6, "F");
          doc.setTextColor("#ffffff");
          doc.setFont("helvetica", "bold");
          doc.setFontSize(8);
          doc.text(`IMPUESTO $`, 153, finalY + 26);

          doc.setFillColor(...backgroundColorBoxLightGray);
          doc.setTextColor("#000000");
          doc.setFont("helvetica", "normal");
          doc.rect(181, finalY + 22, 24, 6, "F");
          doc.text(
            new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
            }).format(iva),
            183,
            finalY + 26
          );

          

          doc.setFillColor(...backgroundColorBoxPurple);
          doc.rect(144, finalY + 29, 37, 6, "F");
          doc.setTextColor("#ffffff");
          doc.setFont("helvetica", "bold");
          doc.setFontSize(8);
          doc.text(`TOTAL $`, 153, finalY + 34);

          doc.setFillColor(...backgroundColorBoxLightGray);
          doc.setTextColor("#000000");
          doc.setFont("helvetica", "normal");
          doc.rect(181, finalY + 29, 24, 6, "F");
          doc.text(
            new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
              maximumFractionDigits: 2,
            }).format(Number(total_general) || 0),
            183,
            finalY + 34
          );

          var lines = doc.splitTextToSize(
            `Observaciones: ${observaciones}`,
            40
          );
          doc.text(145, finalY + 40, lines);

          doc.setFillColor(...backgroundColorBoxLightGray);
          doc.rect(5, finalY + 47, 200, 40, "F");
          doc.setFont("helvetica", "normal");
          doc.text(
            `Confirmado y autorizado por:`,
            47,
            finalY + 57
          );
          doc.text(
            `Para: ${clientes}`,
            125,
            finalY + 57
          );
          doc.setFont("helvetica", "bold");
          doc.text(
            `______________________________`,
            35,
            finalY + 72
          );
          doc.text(
            `______________________________`,
            120,
            finalY + 72
          );
          doc.text(
            `FIRMA(S) AUTORIZADA(S)`,
            42,
            finalY + 77
          );
          doc.text(
            `FIRMA(S) AUTORIZADA(S)`,
            125,
            finalY + 77
          );

          doc.save(`Pedido-${numero}.pdf`);
  }

  // Excel del pedido: hoja "Por modelo" (un renglon por modelo con sus colores,
  // tallas y proporciones) y hoja "Por color y talla" (un renglon por variante).
  // Siempre con la foto del modelo; en el detalle, la del color si tiene propia.
  async function excelOC(id, numero) {
    try {
      Swal.fire({ title: "Armando el Excel", html: "Un momento...", allowOutsideClick: false, onBeforeOpen: () => Swal.showLoading() });
      const modelos = await desglosePedido(id, { conFoto: false });
      Swal.close();
      if (!modelos.length) {
        Swal.fire({ icon: "info", title: "Sin articulos", text: "Este pedido no tiene articulos." });
        return;
      }
      const porModelo = modelos.map((m) => ({
        _idArticulo: m.articulos,
        Pedido: numero, Renglon: m.renglon, Codigo: m.codigo, Modelo: m.nombre,
        Colores: m.desgloseColores, "Proporcion colores": m.proporcionColores,
        Tallas: m.desgloseTallas, "Proporcion tallas": m.proporcionTallas,
        Cantidad: m.piezas, Surtido: m.surtido, "Por surtir": m.pendiente,
        Precio: m.precio, Importe: m.total,
      }));
      const porVariante = [];
      modelos.forEach((m) => m.variantes.forEach((v) => porVariante.push({
        _idArticulo: m.articulos, _idColor: v.idColor,
        Pedido: numero, Renglon: m.renglon, Codigo: m.codigo, Modelo: m.nombre,
        Color: v.color, Talla: v.talla,
        Cantidad: v.cantidad, Surtido: v.surtido, "Por surtir": v.pendiente,
        Precio: v.precio, Importe: v.total,
      })));
      const columnas = (f) => Object.keys(f).filter((k) => !k.startsWith("_"));
      await exportaExcelConFotoOpcional({
        nombreArchivo: `Pedido ${numero}`,
        siempreConFoto: true,
        hojas: [
          { nombre: "Por modelo", filas: porModelo, columnas: columnas(porModelo[0]) },
          { nombre: "Por color y talla", filas: porVariante, columnas: columnas(porVariante[0]) },
        ],
      });
    } catch (err) {
      Swal.close();
      Swal.fire({ icon: "error", title: "No se pudo armar el Excel", text: err.message });
    }
  }

  const headers = [
    // { name: "Activo", field: "activo", sortable: true },
    { name: "Numero", field: "numero", sortable: true },
    { name: "Consecutivo Vendedor", field: "consecutivoVendedor", sortable: true },
    { name: "Tipo", field: "tipo", sortable: true },
    { name: "Fecha", field: "fecha", sortable: true },
    { name: "Cliente", field: "clientes", sortable: true },
    { name: "Vendedor", field: "colaboradores", sortable: true },
    { name: "Piezas", field: "total_cantidad", sortable: true },
    { name: "Piezas surtidas", field: "piezasEntregadas", sortable: true },
    { name: "Piezas Pendientes", field: "piezasPendientes", sortable: true },
    // { name: "Total", field: "total_general", sortable: true },
    { name: "Descargas", field: "accionesDesc", sortable: false },
    { name: "Autorización", field: "accionesAut", sortable: false },
    { name: "Edición", field: "accionesEdit", sortable: false },
  ];

  // prepedidos divididos con su flechita abierta
  const [abiertos, setAbiertos] = useState({});

  // pedidos que salieron de cada prepedido dividido
  const hijosPorPrepedido = useMemo(() => {
    const m = new Map();
    comments.forEach((c) => {
      if (!c.idOrigen) return;
      const k = String(c.idOrigen);
      m.set(k, [...(m.get(k) || []), c].sort((x, y) => String(x.numero).localeCompare(String(y.numero), undefined, { numeric: true })));
    });
    return m;
  }, [comments]);

  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          String(comment.colaboradores ?? "").toLowerCase().includes(search.toLowerCase()) ||
          String(comment.folioVendedor ?? "").toLowerCase().includes(search.toLowerCase()) ||
          String(comment.ordenCompraCliente ?? "").toLowerCase().includes(search.toLowerCase()) ||
          String(comment.clientes ?? "").toLowerCase().includes(search.toLowerCase()) ||
          String(comment.total_cantidad ?? "").toString().includes(search) ||
          // String(comment.total_general ?? "").toString().includes(search) ||
          String(comment.numero ?? "").toString().includes(search)
      );
    }
    if (tipoFiltro) {
      computedComments = computedComments.filter((e) => e.tipo === tipoFiltro);
    }
    if (selectedCliente) {
      computedComments = computedComments.filter((e) =>
        String(e.idClientes ?? "").includes(selectedCliente)
      );
    }
    if (selectedColaborador) {
      computedComments = computedComments.filter((e) =>
        String(e.idColaboradores ?? "").includes(selectedColaborador)
      );
    }
    if (status) {
      computedComments = computedComments.filter((e) =>
        String(e.status ?? "").includes(status)
      );
    }
    if (autorizadoSurtido) {
      computedComments = computedComments.filter((e) =>
        String(e.autorizadoSurtido ?? "").includes(autorizadoSurtido)
      );
    }
    if (autorizadoApartado) {
      computedComments = computedComments.filter((e) =>
        String(e.autorizadoApartado ?? "").includes(autorizadoApartado)
      );
    }

    if (selectedFechaInicio) {
      computedComments = computedComments.filter(
        (e) => e.fecha >= selectedFechaInicio
      );
    }

    if (selectedFechaFin) {
      computedComments = computedComments.filter(
        (e) => e.fecha <= selectedFechaFin
      );
    }

    // Un prepedido dividido se ve como un solo renglon: el pedido que pasa los
    // filtros sube a su prepedido, que suma lo surtido y lo pendiente de todos.
    // Si el prepedido no se cargo (otra fecha), el pedido sale suelto.
    const prepedidos = new Map(comments.map((c) => [String(c._id), c]));
    const agrupados = new Map();
    computedComments.forEach((c) => {
      const padre = prepedidos.get(String(c.idOrigen));
      const llave = String((padre || c)._id);
      const previo = agrupados.get(llave);
      if (previo) {
        if (padre && search) previo.hijoCoincide = true;
        return;
      }
      const hijos = hijosPorPrepedido.get(String((padre || c)._id));
      agrupados.set(llave, !hijos ? c : {
        ...(padre || c),
        hijos,
        hijoCoincide: !!(padre && search),
        piezasEntregadas: hijos.reduce((s, h) => s + (Number(h.piezasEntregadas) || 0), 0),
        piezasPendientes: hijos.reduce((s, h) => s + (Number(h.piezasPendientes) || 0), 0),
      });
    });
    computedComments = [...agrupados.values()];

    setTotalItems(computedComments.length);

    //Sorting comments
    if (
      sorting.field &&
      sorting.field != "total_cantidad" &&
      // sorting.field != "total_general" &&
      sorting.field != "piezasEntregadas" &&
      sorting.field != "piezasPendientes" &&
      sorting.field != "numero" &&
      sorting.field != "consecutivoVendedor"
    ) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    if (
      sorting.field &&
      sorting.order === "asc" &&
      (sorting.field == "total_cantidad" ||
        // sorting.field == "total_general" ||
        sorting.field == "piezasEntregadas" ||
        sorting.field == "piezasPendientes" ||
        sorting.field == "numero" ||
        sorting.field == "consecutivoVendedor")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) > parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    if (
      sorting.field &&
      sorting.order === "desc" &&
      (sorting.field == "total_cantidad" ||
        // sorting.field == "total_general" ||
        sorting.field == "piezasEntregadas" ||
        sorting.field == "piezasPendientes" ||
        sorting.field == "numero" ||
        sorting.field == "consecutivoVendedor")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) < parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [
    comments,
    hijosPorPrepedido,
    currentPage,
    search,
    sorting,
    tipoFiltro,
    selectedCliente,
    selectedColaborador,
    status,
    selectedFechaInicio,
    selectedFechaFin,
    autorizadoApartado,
    autorizadoSurtido,
  ]);

  // bajo cada prepedido abierto van sus pedidos; al buscar uno, su prepedido se abre solo
  const filasVisibles = commentsData.flatMap((a) =>
    (a.hijos && (abiertos[a._id] || a.hijoCoincide) ? [a, ...a.hijos.map((h) => ({ ...h, esHijo: true }))] : [a]));

  const celdaNumero = (a) => (
    <td style={{ whiteSpace: "nowrap" }}>
      {a.hijos ? (
        <Button color="link" size="sm" style={{ padding: "0 6px 0 0" }}
          title={abiertos[a._id] ? "Ocultar los pedidos que se generaron" : "Ver los pedidos que se generaron"}
          onClick={() => setAbiertos((p) => ({ ...p, [a._id]: !p[a._id] }))}>
          <i className={`fas fa-chevron-${abiertos[a._id] || a.hijoCoincide ? "down" : "right"}`}></i>
        </Button>
      ) : null}
      {a.esHijo ? <span style={{ color: "#94a3b8", paddingLeft: 12 }}>└ </span> : null}
      {a.numero}
      {/* OC del cliente y cancelacion solo se ven al desglosar un prepedido dividido */}
      {a.esHijo && a.ordenCompraCliente && a.ordenCompraCliente !== "NA" ? (
        <div style={{ fontSize: 11, color: "#64748b", paddingLeft: 12 }}>OC {a.ordenCompraCliente}</div>
      ) : null}
      {a.esHijo && a.fechaCancelacion ? (
        <div style={{ fontSize: 11, color: "#64748b", paddingLeft: 12 }}>Cancela {a.fechaCancelacion}</div>
      ) : null}
    </td>
  );

  function EditArticulos(
    idOC,
    numero_pedido,
    comisionTDC,
    comisionFlete,
    impuestos,
    subTotal,
    iva,
    total_general,
    total_cantidad,
    surtido,
    clientes,
    idClientes,
    fechaModificado,
    fecha,
    descuento,
    datos
  ) {
    setComisionTDC(comisionTDC);
    setComisionFlete(comisionFlete);
    setSelectedImpuesto(impuestos);
    setSurtido(surtido);
    setIva(iva.toFixed(2));
    setTotalGeneralEdit(total_general);
    setTotalCantidadEdit(total_cantidad);
    setSubTotal(subTotal);
    setNombreClienteEdit(clientes);
    setIdClienteEdit(idClientes);
    setFechaModificado(fechaModificado);
    setFecha(fecha);
    setDescuento(descuento);
    setDescuentoNumero((subTotal * descuento) / 100)

    setInputFields([
      {
        id: uuidv4(),
        colores: "",
        tallas: "",
        articulos: "",
        piezasPorCaja: 0,
        cajas: 0,
        cantidad: 0,
        precio: 0,
        total: 0,
      },
    ]);
    setIdEdit(idOC);
    setNumeroPedido(numero_pedido);
    setPedidoEditar({
      id: idOC, numero: numero_pedido, cliente: clientes, idCliente: idClientes,
      impuestos, descuento, comisionTDC, comisionFlete, fecha,
      ...datos,
    });
    axios
      .get(`${URL_ARTICULOS_PEDIDO}/pedidos/${idOC}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allArticulosPedido = response.data;
        let arrayTabla = allArticulosPedido
          .map((a) => {
            return {
              id: a._id,
              is_active: a.is_active,
              articulos: a.articulos?.[0]?._id,
              renglon: a.renglon || 1,
              cantidad: a.cantidad,
              surtido: a.surtido,
              precio: a.precio,
              total: a.total,
              pendiente_surtir: a.pendiente_surtir,
              piezasPorCaja: a.articulos?.[0]?.piezasPorCaja,
              cajas: a.cantidad / a.articulos?.[0]?.piezasPorCaja,
            };
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(arrayTabla);
        setArticulosPedido(dataFinal);
      })
      .catch((err) => {
        console.log(err);
      });
    setAbrirEditar(true);
  }

  const handleChangeInputExistentesPrecio = (id, event) => {
    const newArticulosPedido = articulosPedido.map((i) => {
      if (id === i.id) {
        i.precio = event;
        let totalParcial = i.cantidad * i.precio;
        i.total = totalParcial;
        i.pendiente_surtir = i.cantidad - i.surtido;
      }
      return i;
    });
    setArticulosPedido(newArticulosPedido);
    ActualizaTotales();
  };

  function BuscaArticuloExistentes(id, event) {
    if (
      inputFields.filter((e) => e.articulos == event.target.value).length > 0 ||
      articulosPedido.filter((e) => e.articulos == event.target.value).length >
        0
    ) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "El modelo ya fue capturado!",
        showConfirmButton: false,
      });
      // const newInputFields = inputFields.map((i) => {
      //   if (id === i.id) {
      //     i.articulos = "";
      //   }
      //   return i;
      // });
      // setInputFields(newInputFields);
    } else {
      articulos.map((a) => {
        if (a._id == event.target.value) {
          let idArticulo = a._id;
          let piezasPorCaja = a.piezasPorCaja;
          handleChangeInputExistentesArticulo(id, idArticulo, piezasPorCaja);
        }
      });
    }
  }

  const handleChangeInputExistentesArticulo = (
    id,
    idArticulo,
    piezasPorCaja
  ) => {
    const newArticulosPedido = articulosPedido.map((i) => {
      if (id === i.id) {
        i.articulos = idArticulo;
        i.piezasPorCaja = piezasPorCaja;
        let totalParcial = i.cantidad * i.precio;
        i.total = totalParcial;
        i.pendiente_surtir = i.cantidad - i.surtido;
      }
      return i;
    });
    setArticulosPedido(newArticulosPedido);
    ActualizaTotales();
  };

  const handleChangeInputCajasExistentes = (id, event) => {
    const newArticulosPedido = articulosPedido.map((i) => {
      if (id === i.id) {
        i.cajas = event.target.value;
        i.cantidad =
          parseFloat(event.target.value) * parseFloat(i.piezasPorCaja);
        let totalParcial = i.cantidad * i.precio;
        i.total = totalParcial;
        i.pendiente_surtir =
          parseFloat(event.target.value) * parseFloat(i.piezasPorCaja) -
          parseFloat(i.surtido);
      }
      return i;
    });
    setArticulosPedido(newArticulosPedido);
    ActualizaTotales();
  };

  const handleChangeInputCantidadExistentes = (id, event) => {
    const newArticulosPedido = articulosPedido.map((i) => {
      if (id === i.id) {
        i.cantidad = parseFloat(event.target.value);
        i.cajas = parseFloat(event.target.value) / parseFloat(i.piezasPorCaja);
        let totalParcial = i.cantidad * i.precio;
        i.total = totalParcial;
        i.pendiente_surtir =
          parseFloat(event.target.value) - parseFloat(i.surtido);
      }
      return i;
    });
    setArticulosPedido(newArticulosPedido);
    ActualizaTotales();
  };

  const handleChangeInputCajas = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.cajas = event.target.value;
        i.cantidad =
          parseFloat(event.target.value) * parseFloat(i.piezasPorCaja);
        let totalParcial = i.cantidad * i.precio;
        i.total = totalParcial;
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  const handleChangeInputCantidad = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.cantidad = event.target.value;
        i.cajas = parseFloat(event.target.value) / parseFloat(i.piezasPorCaja);
        let totalParcial = i.cantidad * i.precio;
        i.total = totalParcial;
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  const handleAddFields = () => {
    const ultimo = inputFields[inputFields.length - 1];
    setInputFields([
      ...inputFields,
      {
        id: uuidv4(),
        colores: "",
        tallas: "",
        articulos: "",
        piezasPorCaja: 0,
        cajas: 0,
        cantidad: 0,
        precio: 0,
        total: 0,
      },
    ]);
  };

  const handleRemoveFields = (id) => {
    const values = [...inputFields];
    values.splice(
      values.findIndex((value) => value.id === id),
      1
    );
    setInputFields(values);
    let KG = articulosPedido.concat(values);
    let totalKG = KG.map((c) => parseFloat(c.cantidad));
    let TK = totalKG.reduce((t, total, index) => t + total, 0);
    setTotalCantidadEdit(TK);

    let importesExistentes = articulosPedido.map((c) => parseFloat(c.total));
    let importesNuevos = values.map((c) => parseFloat(c.total));
    let importes = importesExistentes.concat(importesNuevos);
    let TG = importes.reduce((t, total, index) => t + total, 0);

    if (selectedImpuesto != 0) {
      setIva((selectedImpuesto * (TG - descuentoNumero)) / 100);
    } else {
      setIva(0);
    }
    setTotalGeneralEdit(
      (selectedImpuesto * (TG - descuentoNumero)) / 100 +
        TG +
        parseFloat(comisionTDC) +
        parseFloat(comisionFlete)
    );
  };

  const handleChangeInputPrecio = (id, value) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.precio = value;
        let totalParcial = i.cantidad * value;
        i.total = totalParcial;
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  // El mismo modelo puede ir otra vez (otro renglon u otro color): ya no se bloquea.
  // Al guardar, los renglones nuevos se numeran despues del ultimo del pedido.
  function BuscaArticulo(id, event) {
    const a = articulos.find((x) => x._id == event.target.value);
    if (a) handleChangeInputArticulo(id, a._id, a.piezasPorCaja, a.venta);
  }

  const handleChangeInputArticulo = (id, idArticulo, piezasPorCaja, precio) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.articulos = idArticulo;
        i.piezasPorCaja = piezasPorCaja;
        i.precio = precio;
        let totalParcial = i.cantidad * i.precio;
        i.total = totalParcial;
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  function ActualizaTotales() {
    let DESC = 0
    let ivaTT = 0
    let activos = articulosPedido.filter((e) => e.is_active == "Si");
    let activos2 = activos.concat(inputFields);
    let cantidadActivos = activos2.map((c) => parseFloat(c.cantidad));
    let TA = cantidadActivos.reduce((t, total, index) => t + total, 0);
    setTotalCantidadEdit(TA);

    let totalActivos = activos2.map((c) => parseFloat(c.total));
    let TG = totalActivos.reduce((t, total, index) => t + total, 0);
    setSubTotal(TG.toFixed(2));

    if (descuento != 0) {
      DESC = (TG * descuento) / 100;
    }else{
      DESC = 0
    }

    if (selectedImpuesto != 0) {
      setIva((selectedImpuesto * (TG - DESC)) / 100);
      ivaTT = (selectedImpuesto * (TG - DESC)) / 100
    } else {
      setIva(0);
    }


    setTotalGeneralEdit(TG + ivaTT + comisionFlete + comisionTDC - DESC);
    setFechaModificado(endDate);
  }
  function calculaDescuento(e) {
    setDescuento(e);
    let temp1 = (subTotal * e) / 100;

    setDescuentoNumero(temp1);

    if (selectedImpuesto != 0) {
      setIva((selectedImpuesto * (subTotal - temp1)) / 100);
    } else {
      setIva(0);
    }
    
    let temp = subTotal - temp1;

    let totTemp = temp + parseFloat(comisionTDC) + parseFloat(comisionFlete)+ parseFloat((selectedImpuesto * (subTotal - temp1)) / 100);

    setTotalGeneralEdit(totTemp);
  }
  const savePedido = async (event) => {
    event.preventDefault();
    setValidaBoton(false);
    toggleProgreso();
    let totalPedido = inputFields.length + articulosPedido.length;
    const URL_PEDIDOS_EDIT = `${URL_PEDIDOS}/${idEdit}`;
    try {
      await axios
        .patch(
          URL_PEDIDOS_EDIT,
          {
            total_general: parseFloat(total_general_edit).toFixed(2),
            total_cantidad: total_cantidad_edit,
            piezasPendientes: total_cantidad_edit,
            editArticulos: user.id,
            comisionTDC,
            comisionFlete,
            subTotal: parseFloat(subTotal).toFixed(2),
            iva: parseFloat(iva).toFixed(2),
            impuestos: selectedImpuesto,
            editado: "Si",
            fechaModificado,
            descuento
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
        .then(() => {
          // renglon: los modelos nuevos van despues del ultimo renglon del pedido
          // (las variantes del mismo modelo nuevo comparten numero)
          const ultimo = articulosPedido.reduce((m, x) => Math.max(m, x.renglon || 1), 0);
          const nuevos = [...new Set(inputFields.filter((x) => x.articulos).map((x) => x.articulos))];
          inputFields.map((a) => {
            if (a.articulos != "" && a.cantidad != 0) {
              axios
                .post(
                  URL_ARTICULOS_PEDIDO,
                  {
                    pedidos: idEdit,
                    renglon: ultimo + nuevos.indexOf(a.articulos) + 1,
                    articulos: a.articulos,
                    colores: a.colores,
                    tallas: a.tallas,
                    cantidad: parseFloat(a.cantidad),
                    cantidadProcesos: 0,
                    precio: parseFloat(a.precio),
                    total: parseFloat(a.total).toFixed(2),
                    surtido: 0,
                    pendiente_surtir: parseFloat(a.cantidad),
                    clientes: idClienteEdit,
                    fecha
                  },
                  {
                    headers: {
                      Authorization: `Bearer: ${localStorage.getItem(
                        "app_token"
                      )}`,
                    },
                  }
                )
                .then(() => {
                  totalPedido = totalPedido - 1;
                  if (totalPedido == 0) {
                    axios.post(
                      URL_LOGS,
                      {
                        tipo: "Editar Pedido",
                        detalle: `${numero_pedido}`,
                        user: user.id,
                      },
                      {
                        headers: {
                          Authorization: `Bearer: ${localStorage.getItem(
                            "app_token"
                          )}`,
                        },
                      }
                    );
                    Swal.fire("Good job!", "Creado con exito", `success`);
                    setTimeout(() => {
                      window.location.reload();
                    }, 1000);
                  }
                });
            } else {
              totalPedido = totalPedido - 1;
              if (totalPedido == 0) {
                axios.post(
                  URL_LOGS,
                  {
                    tipo: "Editar Pedido",
                    detalle: `${numero_pedido}`,
                    user: user.id,
                  },
                  {
                    headers: {
                      Authorization: `Bearer: ${localStorage.getItem(
                        "app_token"
                      )}`,
                    },
                  }
                );
                Swal.fire("Good job!", "Creado con exito", `success`);
                setTimeout(() => {
                  window.location.reload();
                }, 1000);
              }
            }
          });
          articulosPedido.map((a) => {
            axios
              .patch(
                `${URL_ARTICULOS_PEDIDO}/${a.id}`,
                {
                  articulos: a.articulos,
                  colores: a.colores,
                  tallas: a.tallas,
                  cantidad: parseFloat(a.cantidad),
                  precio: parseFloat(a.precio),
                  total: parseFloat(a.total).toFixed(2),
                  pendiente_surtir: parseFloat(a.pendiente_surtir),
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              )
              .then(() => {
                totalPedido = totalPedido - 1;
                if (totalPedido == 0) {
                  axios.post(
                    URL_LOGS,
                    {
                      tipo: "Editar Pedido",
                      detalle: `${numero_pedido}`,
                      user: user.id,
                    },
                    {
                      headers: {
                        Authorization: `Bearer: ${localStorage.getItem(
                          "app_token"
                        )}`,
                      },
                    }
                  );
                  Swal.fire("Good job!", "Creado con exito", `success`);
                  setTimeout(() => {
                    window.location.reload();
                  }, 1000);
                }
              });
          });
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
            footer: `${error.response.data}`,
          });
          console.log(error);
        });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
        footer: `${error.response.data}`,
      });
      console.log(error);
    }
  };

  function calculaImpuesto(e) {
    setSelectedImpuesto(e);
    if (e != 0) {
      setIva((e * (subTotal - descuentoNumero)) / 100);
    } else {
      setIva(0);
    }
    setTotalGeneralEdit(
      (e * subTotal) / 100 +
        subTotal +
        parseFloat(comisionTDC) +
        parseFloat(comisionFlete) -
        parseFloat(descuentoNumero)
    );
  }

  function jalaComisionTDC(e) {
    setComisionTDC(e);
    if (selectedImpuesto != 0) {
      setIva((selectedImpuesto * (subTotal - descuentoNumero)) / 100);
    } else {
      setIva(0);
    }
    setTotalGeneralEdit(
      (selectedImpuesto * (subTotal - descuentoNumero)) / 100 +
        subTotal +
        parseFloat(e) +
        parseFloat(comisionFlete) -
        parseFloat(descuentoNumero)
    );
  }

  function jalaComisionFlete(e) {
    setComisionFlete(e);
    if (selectedImpuesto != 0) {
      setIva((selectedImpuesto * (subTotal - descuentoNumero)) / 100);
    } else {
      setIva(0);
    }
    setTotalGeneral(
      (selectedImpuesto * (subTotal - descuentoNumero)) / 100 +
        subTotal -
        parseFloat(descuentoNumero) +
        parseFloat(comisionTDC) +
        parseFloat(e)
    );
  }

  function autorizaCambio() {
    if (password == PASSWORD_CAMBIA_PRECIO) {
      setCambiarPrecio(true);
      toggleCambiaPrecio();
    } else {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "La contraseña es incorrecta!",
      });
    }
  }

  function bajaArticulo(id) {
    const URL_AUTORIZADO_HIJO = `${URL_ARTICULOS_PEDIDO}/autorizadoApartado/${idEdit}`;
    const temp = articulosPedido.map((i) => {
      if (id === i.id) {
        i.is_active = "No";
      }
      return i;
    });

    Swal.fire({
      title: "Estas seguro?",
      text: "Se dara de baja!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, dar de Baja!",
    }).then((result) => {
      if (result.isConfirmed) {
        let activos = temp.filter((e) => e.is_active == "Si");
        let cantidadActivos = activos.map((c) => parseFloat(c.cantidad));
        let TA = cantidadActivos.reduce((t, total, index) => t + total, 0);
        setTotalCantidadEdit(TA);

        let totalActivos = activos.map((c) => parseFloat(c.total));
        let TG = totalActivos.reduce((t, total, index) => t + total, 0);
        setSubTotal(TG);

        let IT;
        if (selectedImpuesto != 0) {
          IT = (selectedImpuesto * TG) / 100;
        } else {
          IT = 0;
        }

        setIva(IT);

        let TGT =
          (selectedImpuesto * TG) / 100 +
          TG +
          parseFloat(comisionTDC) +
          parseFloat(comisionFlete);

        setTotalGeneralEdit(TGT.toFixed(2));

        axios
          .patch(
            `${URL_ARTICULOS_PEDIDO}/${id}`,
            {
              is_active: "No",
              autorizadoApartado: "No",
              autorizadoSurtido: "No",
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then((response) => {
            //Patch Pedidos
            axios
              .patch(
                `${URL_PEDIDOS}/${idEdit}`,
                {
                  total_cantidad: TA,
                  total_general: TGT,
                  subTotal: TG,
                  iva: IT,
                  autorizadoApartado: "No",
                  autorizadoSurtido: "No",
                  autorizoApartado: user.id,
                  fechaModificado: hoy,
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              )
              .then(() => {
                axios
                  .patch(
                    URL_AUTORIZADO_HIJO,
                    {
                      autorizadoApartado: "No",
                      autorizadoSurtido: "No",
                    },
                    {
                      headers: {
                        Authorization: `Bearer: ${localStorage.getItem(
                          "app_token"
                        )}`,
                      },
                    }
                  )
                  .then(() => {
                    const newAP = articulosPedido.map((i) => {
                      if (id === i.id) {
                        i.is_active = "No";
                      }
                      return i;
                    });
                    setArticulosPedido(newAP);

                    const newPed = comments.map((i) => {
                      if (idEdit === i._id) {
                        i.total_cantidad = TA;
                        i.total_general = TGT;
                        i.subTotal = TG;
                        i.iva = IT;
                        i.autorizadoApartado = "No";
                        i.autorizadoSurtido = "No";
                      }
                      return i;
                    });
                    setComments(newPed);

                    Swal.fire({
                      position: "center",
                      icon: "success",
                      title: "Se dio de Baja",
                      showConfirmButton: false,
                      timer: 2000,
                    });
                  })
                  .catch((error) => {
                    Swal.fire({
                      icon: "error",
                      title: "Oops...",
                      text: "Something went wrong!",
                      footer: `${error.response.data}`,
                    });
                    console.log(error);
                  });
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  footer: `${error.response.data}`,
                });
                console.log(error);
              });
            //Termina Patch Pedidos
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          });
      }
    });
  }

  function altaArticulo(id) {
    const temp = articulosPedido.map((i) => {
      if (id === i.id) {
        i.is_active = "Si";
      }
      return i;
    });

    Swal.fire({
      title: "Estas seguro?",
      text: "Se dara de Alta!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, dar de Alta!",
    }).then((result) => {
      if (result.isConfirmed) {
        let activos = temp.filter((e) => e.is_active == "Si");
        let cantidadActivos = activos.map((c) => parseFloat(c.cantidad));
        let TA = cantidadActivos.reduce((t, total, index) => t + total, 0);
        setTotalCantidadEdit(TA);

        let totalActivos = activos.map((c) => parseFloat(c.total));
        let TG = totalActivos.reduce((t, total, index) => t + total, 0);
        setSubTotal(TG);

        let IT;
        if (selectedImpuesto != 0) {
          IT = (selectedImpuesto * TG) / 100;
        } else {
          IT = 0;
        }

        setIva(IT);

        let TGT =
          (selectedImpuesto * TG) / 100 +
          TG +
          parseFloat(comisionTDC) +
          parseFloat(comisionFlete);

        setTotalGeneralEdit(TGT.toFixed(2));

        axios
          .patch(
            `${URL_ARTICULOS_PEDIDO}/${id}`,
            {
              is_active: "Si",
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then((response) => {
            //Patch Pedidos
            axios
              .patch(
                `${URL_PEDIDOS}/${idEdit}`,
                {
                  total_cantidad: TA,
                  total_general: TGT,
                  subTotal: TG,
                  iva: IT,
                  autorizadoApartado: "Si",
                  autorizadoSurtido: "Si",
                  autorizoApartado: user.id,
                  fechaModificado: hoy,
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              )
              .then((response) => {
                const newAP = articulosPedido.map((i) => {
                  if (id === i.id) {
                    i.is_active = "Si";
                  }
                  return i;
                });
                setArticulosPedido(newAP);

                const newPed = comments.map((i) => {
                  if (idEdit === i._id) {
                    i.total_cantidad = TA;
                    i.total_general = TGT;
                    i.subTotal = TG;
                    i.iva = IT;
                    i.autorizadoApartado = "Si";
                    i.autorizadoSurtido = "Si";
                  }
                  return i;
                });
                setComments(newPed);

                Swal.fire({
                  position: "center",
                  icon: "success",
                  title: "Se dio de Alta",
                  showConfirmButton: false,
                  timer: 2000,
                });
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  footer: `${error.response.data}`,
                });
                console.log(error);
              });
            //Termina Patch Pedidos
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          });
      }
    });
  }

  function desautorizarSurtido(id) {
    const URL_AUTORIZADO = `${URL_PEDIDOS}/${id}`;
    const URL_AUTORIZADO_HIJO = `${URL_ARTICULOS_PEDIDO}/autorizadoSurtido/${id}`;
    Swal.fire({
      title: "Estas seguro?",
      text: "Se quitara la autorizacion de Surtir!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, quitar autorizacion!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .patch(
            URL_AUTORIZADO,
            {
              autorizadoSurtido: "No",
              autorizadoApartado: "No",
              autorizoSurtido: user.id,
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then((response) => {
            axios
              .patch(
                URL_AUTORIZADO_HIJO,
                {
                  autorizadoSurtido: "No",
                  autorizadoApartado: "No",
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              )
              .then(() => {
                axios.post(
                  URL_LOGS,
                  {
                    tipo: "Desautorizar Surtido",
                    detalle: `${numero_pedido} ${fecha}`,
                    user: user.id,
                  },
                  {
                    headers: {
                      Authorization: `Bearer: ${localStorage.getItem(
                        "app_token"
                      )}`,
                    },
                  }
                );
                Swal.fire({
                  position: "center",
                  icon: "success",
                  title: "Se quito la autorizacion",
                  showConfirmButton: false,
                  timer: 2000,
                });
                const newComments = comments.map((i) => {
                  if (id === i._id) {
                    i.autorizadoSurtido = "No";
                    i.autorizadoApartado = "No";
                  }
                  return i;
                });
                setComments(newComments);
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  footer: `${error.response.data}`,
                });
                console.log(error);
              });
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          });
      }
    });
  }

  function autorizarPrepedido(id, numero) {
    Swal.fire({
      title: "Estas seguro?",
      text: `El prepedido ${numero} se convertira en Pedido!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, convertir!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .patch(
            `${URL_PEDIDOS}/${id}`,
            {
              tipo: "Pedido",
              autorizadoPrepedido: "Si",
              autorizadoApartado: "Si",
              autorizoPrepedido: user.id,
            },
            { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } }
          )
          .then(() => {
            axios.post(
              URL_LOGS,
              { tipo: "Autorizar Prepedido", detalle: `${numero}`, user: user.id },
              { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } }
            );
            Swal.fire("Good job!", "Convertido a Pedido", "success");
            setTimeout(() => { window.location.reload(); }, 1000);
          })
          .catch((error) => {
            Swal.fire({ icon: "error", title: "Oops...", text: "Something went wrong!",
              footer: `${error.response?.data?.message || error.message}` });
          });
      }
    });
  }

  function autorizarSurtido(id) {
    const URL_AUTORIZADO = `${URL_PEDIDOS}/${id}`;
    const URL_AUTORIZADO_HIJO = `${URL_ARTICULOS_PEDIDO}/autorizadoSurtido/${id}`;
    Swal.fire({
      title: "Estas seguro?",
      text: "Se va a autorizar Surtir!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, autorizar!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .patch(
            URL_AUTORIZADO,
            {
              autorizadoSurtido: "Si",
              autorizadoApartado: "Si",
              autorizoSurtido: user.id,
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then((response) => {
            axios
              .patch(
                URL_AUTORIZADO_HIJO,
                {
                  autorizadoSurtido: "Si",
                  autorizadoApartado: "Si",
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              )
              .then(() => {
                axios.post(
                  URL_LOGS,
                  {
                    tipo: "Autorizar Surtido",
                    detalle: `${numero_pedido} ${fecha}`,
                    user: user.id,
                  },
                  {
                    headers: {
                      Authorization: `Bearer: ${localStorage.getItem(
                        "app_token"
                      )}`,
                    },
                  }
                );
                Swal.fire({
                  position: "center",
                  icon: "success",
                  title: "Se Autorizo",
                  showConfirmButton: false,
                  timer: 2000,
                });
                const newComments = comments.map((i) => {
                  if (id === i._id) {
                    i.autorizadoSurtido = "Si";
                    i.autorizadoApartado = "Si";
                  }
                  return i;
                });
                setComments(newComments);
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  footer: `${error.response.data}`,
                });
                console.log(error);
              });
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          });
      }
    });
  }

        function desarrollo(){
      axios
        .get(
          `${URL_PEDIDOS}Desarrollo`,
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )      
        .then(() => {
          Swal.fire("Good job!", "Enviado con exito", "success");
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
            footer: `${error.response.data}`,
          });
          console.log(error);
        });
  }

  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_pedidos ? (
        <div className="card col-12">
          {!AbrirEditar ? (
            <>
              <Row>
                <Col md={8}>
                  {user.pedidos_create ? (
                    <Button title="Capturar un pedido nuevo"
                      size="sm"
                      type="submit"
                      className="btn btn-success"
                      href="/PedidosCreate"
                    >
                      Nuevo Pedido
                    </Button>
                  ) : (
                    <Button title="Capturar un pedido nuevo"
                      size="sm"
                      type="submit"
                      className="btn btn-success"
                      disabled
                    >
                      Nuevo Pedido
                    </Button>
                  )}
                  {/* {user.articulos_create ? (
                    <Button
                      size="sm"
                      className="btn btn-info"
                      title="Dar de alta modelos desde un layout de Excel"
                      onClick={() => setModalImportar(true)}
                    >
                      Alta de modelos (layout)
                    </Button>
                  ) : undefined} */}
                  {user.pedidos_create ? (
                    <Button
                      size="sm"
                      className="btn btn-primary"
                      title="Subir el archivo de prepedidos del cliente"
                      onClick={() => setModalPrepedido(true)}
                    >
                      Subir prepedidos (Excel)
                    </Button>
                  ) : undefined}
                  <Button title="Volver al menú"
                    size="sm"
                    href="/MenuVentas"
                    className="btn btn-danger"
                    id="botonListado"
                  >
                    Regresar
                  </Button>
                </Col>
                <Col sm={4} className="text-right">
                  <MenuDescargas
                    opciones={[
                      { label: "PDF del listado", icon: "far fa-file-pdf", onClick: PDFTabla },
                      { label: "Excel del listado", icon: "far fa-file-excel", onClick: excel },
                      { label: "Excel por talla y color", icon: "fas fa-th", onClick: () => descargaPorTallaColor("pedidos", "PedidosPorTallaColor") },
                      { separador: true },
                      { label: "Enviar por correo", icon: "fas fa-at", onClick: toggleMail },
                    ]}
                  />
                </Col>
              </Row>
              <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
                <ModalHeader toggle={toggleMail}>
                  <h4>Enviar Listado Pedidos</h4>
                </ModalHeader>
                <ModalBody>
                  <Label className="mr-sm-2">Email</Label>
                  <Input
                    className="col-sm-12"
                    type="text"
                    value={mailTo}
                    required
                    onChange={(e) => {
                      setMailTo(e.target.value);
                    }}
                  />
                </ModalBody>
                <ModalFooter>
                  <Button title="Enviar el listado al correo" size="sm" color="success" onClick={enviaMail}>
                    Enviar
                  </Button>
                </ModalFooter>
              </Modal>
              <h3 align="center">Pedidos de Clientes</h3>
              <div className="row">
                <div className="col-md-8">
                  <Pagination
                    total={totalItems}
                    itemsPerPage={ITEMS_PER_PAGE}
                    currentPage={currentPage}
                    onPageChange={(page) => setCurrentPage(page)}
                  />
                </div>
                <div className="col-md-4 d-flex flex-row-reverse">
                  <Search
                    onSearch={(value) => {
                      setSearch(value);
                      setCurrentPage(1);
                    }}
                  />
                </div>
              </div>
              <Row>
                <Col md={2}>
                  <Label className="mr-sm-2">Fecha Inicio</Label>
                  <Input
                    bsSize="sm"
                    type="date"
                    value={selectedFechaInicio}
                    required
                    onChange={(e) => {
                      setSelectedFechaInicio(e.target.value);
                    }}
                  />
                </Col>
                <Col md={2}>
                  <Label className="mr-sm-2">Fecha Fin</Label>
                  <Input
                    bsSize="sm"
                    type="date"
                    value={selectedFechaFin}
                    required
                    onChange={(e) => {
                      setSelectedFechaFin(e.target.value);
                    }}
                  />
                </Col>

                <Col md={2}>
                  <Label>Autorizado</Label>
                  <Input
                    bsSize="sm"
                    type="select"
                    value={autorizadoApartado}
                    required
                    onChange={(e) => {
                      setAutorizadoApartado(e.target.value);
                      setCurrentPage(1);
                    }}
                  >
                    <option value="">Selecciona</option>
                    <option value="Si">Si</option>
                    <option value="No">No</option>
                  </Input>
                </Col>

                <Col md={2}>
                  <Label>Autorizado Surtir</Label>
                  <Input
                    bsSize="sm"
                    type="select"
                    value={autorizadoSurtido}
                    required
                    onChange={(e) => {
                      setAutorizadoSurtido(e.target.value);
                      setCurrentPage(1);
                    }}
                  >
                    <option value="">Selecciona</option>
                    <option value="Si">Si</option>
                    <option value="No">No</option>
                  </Input>
                </Col>

                <Col md={2}>
                  <Label>Status</Label>
                  <Input
                    bsSize="sm"
                    type="select"
                    value={status}
                    required
                    onChange={(e) => {
                      setStatus(e.target.value);
                      setCurrentPage(1);
                    }}
                  >
                    {/* <option value="">Selecciona</option> */}
                    <option value="Abierto">Abierto</option>
                    <option value="Cerrado">Cerrado</option>
                  </Input>
                </Col>
              </Row>
              <br />
              <Table
                size="sm"
                striped
                borderless
                className="table-responsive-xl"
              >
                <TableHeader
                  headers={headers}
                  onSorting={(field, order) => setSorting({ field, order })}
                />
                <tr>
                  <td></td>
                  <td></td>
                  <td style={{ paddingTop: "0px" }}>
                    <Input
                      bsSize="sm"
                      type="select"
                      value={tipoFiltro}
                      onChange={(e) => {
                        setTipoFiltro(e.target.value);
                        setCurrentPage(1);
                      }}
                    >
                      <option value="">Todos</option>
                      <option value="Pedido">Pedido</option>
                      <option value="Prepedido">Prepedido</option>
                    </Input>
                  </td>
                  <td></td>
                  <td style={{ paddingTop: "0px" }}>
                    <Input
                      bsSize="sm"
                      type="select"
                      value={selectedCliente}
                      onChange={(e) => {
                        setSelectedCliente(e.target.value);
                        setCurrentPage(1);
                      }}
                    >
                      <option value="0">Selecciona</option>
                      {clientes
                        .sort((a, b) =>
                          a.nombre_comercial > b.nombre_comercial ? 1 : -1
                        )
                        .map((a) => {
                          return (
                            <option value={a._id}>{a.nombre_comercial}</option>
                          );
                        })}
                    </Input>
                  </td>
                  <td style={{ paddingTop: "0px" }}>
                    <Input
                      bsSize="sm"
                      type="select"
                      value={selectedColaborador}
                      onChange={(e) => {
                        setSelectedColaborador(e.target.value);
                        setCurrentPage(1);
                      }}
                    >
                      <option value="">Selecciona un Vendedor</option>
                      {colaboradores
                        .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
                        .map((a) => {
                          return (
                            <option value={a._id}>
                              {a.nombre} {a.apellido}
                            </option>
                          );
                        })}
                    </Input>
                  </td>
                </tr>
                <tbody>
                  {filasVisibles.map((a) => {
                    if (a.status === "Dividido") {
                      return (
                        <tr style={{ backgroundColor: "#f8fafc" }}>
                          {celdaNumero(a)}
                          <td>{a.folioVendedor}</td>
                          <td><span style={{ color: "#f59e0b", fontWeight: 700 }}>PREPEDIDO</span></td>
                          <td>{a.fecha}</td>
                          <td>{a.clientes}</td>
                          <td>{a.colaboradores}</td>
                          <td>{new Intl.NumberFormat("en-US").format(a.total_cantidad)}</td>
                          <td>{new Intl.NumberFormat("en-US").format(a.piezasEntregadas)}</td>
                          <td>{new Intl.NumberFormat("en-US").format(a.piezasPendientes)}</td>
                          <td colSpan={3} style={{ color: "#64748b", whiteSpace: "nowrap" }}>
                            DIVIDIDO{a.hijos?.length ? ` en ${a.hijos.length} pedido(s)` : ""}{" "}
                            <Button size="sm" color="info" title="Ver el detalle de los pedidos de este prepedido"
                              onClick={() => setPrepedidoDetalle(a)}>
                              <i className="fas fa-list-alt"></i> Ver detalle
                            </Button>
                          </td>
                        </tr>
                      );
                    }
                    if (a.activo == "No") {
                      return (
                        <tr style={{ backgroundColor: "#ed8c8c" }}>
                          {/* <td>{a.activo}</td> */}
                          {celdaNumero(a)}
                          <td>{a.folioVendedor}</td>
                          <td>
                            {a.tipo === "Prepedido" ? (
                              <span style={{ color: "#f59e0b", fontWeight: 700 }}>PREPEDIDO</span>
                            ) : ("Pedido")}
                          </td>
                          <td>{a.fecha}</td>
                          <td>{a.clientes}</td>
                          <td>{a.colaboradores}</td>
                          <td></td>
                          <td align="right"></td>
                          <td>CANCELADO</td>
                          <td></td>
                          <td></td>
                          <td></td>
                        </tr>
                      );
                    } else {
                      return (
                        <tr style={a.esHijo ? { backgroundColor: "#f8fafc" } : undefined}>
                          {/* <td>{a.activo}</td> */}
                          {celdaNumero(a)}
                          <td>{a.folioVendedor}</td>
                          <td>
                            {a.tipo === "Prepedido" ? (
                              <span style={{ color: "#f59e0b", fontWeight: 700 }}>PREPEDIDO</span>
                            ) : ("Pedido")}
                          </td>
                          <td>{a.fecha}</td>
                          <td>{a.clientes}</td>
                          <td>{a.colaboradores}</td>
                          <td>
                            {new Intl.NumberFormat("en-US").format(
                              a.total_cantidad
                            )}
                          </td>
                          <td>
                            {new Intl.NumberFormat("en-US").format(
                              a.piezasEntregadas
                            )}
                          </td>
                          <td>
                            {new Intl.NumberFormat("en-US").format(
                              a.piezasPendientes
                            )}
                          </td>
                          {/* <td align="right">
                            {new Intl.NumberFormat("en-US", {
                              style: "currency",
                              currency: "USD",
                              maximumFractionDigits: 2,
                              
                            }).format(a.total_general)}
                          </td> */}
                          {/* Descargas: PDF y Excel del pedido */}
                          <td style={{ whiteSpace: "nowrap" }}>
                            {user.pedidos_create ? (
                              <div style={{ display: "flex", gap: 6 }}>
                                {a.status == "Abierto" ? (
                                  <>
                                    <Button title="PDF del pedido"
                                      size="sm"
                                      className="btn"
                                      color="danger"
                                      onClick={(e) =>
                                        PDFOC(
                                          a.fecha,
                                          a.colaboradores,
                                          a.idClientes,
                                          a.clientes,
                                          a.total_cantidad,
                                          a.total_general,
                                          a.observaciones,
                                          a.numero,
                                          a.impuestos,
                                          a.descuento,
                                          a.comisionFlete,
                                          a.comisionTDC,
                                          a._id,
                                          a.calle,
                                          a.numero_ext,
                                          a.numero_int,
                                          a.pais,
                                          a.estado,
                                          a.ciudad,
                                          a.delegacion,
                                          a.colonia,
                                          a.cp,
                                          a.RFC,
                                          a.paqueteria,
                                          a.codigoClientes,
                                          a.autorizadoApartado,
                                          a.autorizadoSurtido,
                                          a.telefono,
                                          a.editado,
                                          a.editPedido,
                                          a.autorizoApartado,
                                          a.autorizoSurtido,
                                          a.subTotal,
                                          a.iva
                                        )
                                      }
                                    >
                                      <i class="far fa-file-pdf"></i>
                                    </Button>
                                    <Button title="Excel del pedido"
                                      size="sm"
                                      className="btn"
                                      color="primary"
                                      onClick={(e) => excelOC(a._id, a.numero)}
                                    >
                                      <i class="far fa-file-excel"></i>
                                    </Button>
                                  </>
                                ) : undefined}
                              </div>
                            ) : undefined}
                          </td>
                          {/* Autorizacion: prepedido, surtido, cerrar, baja */}
                          <td style={{ whiteSpace: "nowrap" }}>
                            {user.pedidos_create ? (
                              <div style={{ display: "flex", gap: 6 }}>
                                {a.tipo === "Prepedido" &&
                                user.pedidos_autorizar &&
                                a.status == "Abierto" ? (
                                  <>
                                  <Button
                                    color="secondary"
                                    size="sm"
                                    title="Dividir en varios pedidos"
                                    onClick={(e) => { setPrepedidoDividir(a); setModalDividir(true); }}
                                  >
                                    <i class="fas fa-code-branch"></i>
                                  </Button>
                                  <Button
                                    color="warning"
                                    size="sm"
                                    title="Autorizar y convertir en Pedido"
                                    onClick={(e) => autorizarPrepedido(a._id, a.numero)}
                                  >
                                    <i class="fas fa-check-double"></i>
                                  </Button>
                                  </>
                                ) : undefined}

                                {a.surtido == "No" &&
                                user.pedidos_autorizar &&
                                a.status == "Abierto" ? (
                                  a.autorizadoSurtido == "Si" ? (
                                    <span>
                                      <Button title="Autorizar / desautorizar surtido"
                                        color="primary"
                                        id="Baja"
                                        onClick={(e) =>
                                          desautorizarSurtido(a._id)
                                        }
                                        size="sm"
                                      >
                                        <i class="fas fa-truck"></i>
                                      </Button>
                                    </span>
                                  ) : (
                                    <span>
                                      <Button title="Autorizar / desautorizar surtido"
                                        color="danger"
                                        onClick={(e) => autorizarSurtido(a._id)}
                                        size="sm"
                                      >
                                        <i class="fas fa-truck"></i>
                                      </Button>
                                    </span>
                                  )
                                ) : undefined}

                                {a.surtido == "No" && user.pedidos_autorizar ? (
                                  <>
                                    <StatusMultiple
                                      idStatus={a._id}
                                      status={a.status}
                                      URL_STATUS={URL_PEDIDOS}
                                      hijo={`${URL_ARTICULOS_PEDIDO}/baja`}
                                      onStatusChange={(
                                        id,
                                        nuevoStatus,
                                      ) => {
                                        setComments((prev) =>
                                          prev.map((item) =>
                                            item._id === id
                                              ? {
                                                  ...item,
                                                  status: nuevoStatus,
                                                }
                                              : item
                                          )
                                        );
                                      }}
                                    />

                                    <BajaMultiple
                                      idStatus={a._id}
                                      is_active={a.activo}
                                      URL_BAJA={URL_PEDIDOS}
                                      hijo={`${URL_ARTICULOS_PEDIDO}/baja`}
                                      onStatusChange={(id, nuevoEstado) => {
                                        setComments((prev) =>
                                          prev.map((item) =>
                                            item._id === id
                                              ? { ...item, activo: nuevoEstado }
                                              : item
                                          )
                                        );
                                      }}
                                    />
                                  </>
                                ) : undefined}
                              </div>
                            ) : undefined}
                          </td>
                          {/* Edicion: fotos, editar, articulos, generar OC */}
                          <td style={{ whiteSpace: "nowrap" }}>
                            <div style={{ display: "flex", gap: 6 }}>
                              <Button title="Fotos de los modelos (una por renglón)" color="secondary" size="sm"
                                onClick={() => setPedidoFotos(a)}>
                                <i className="fas fa-camera"></i>
                              </Button>
                              {user.menu_reportes ? (
                                <Button title="Seguimiento de este pedido" color="secondary" size="sm"
                                  href={`/SeguimientoGeneral?pedido=${a.numero}`}>
                                  <i className="fas fa-route"></i>
                                </Button>
                              ) : undefined}
                              {a.surtido == "No" ? (
                              a.status == "Abierto" && a.activo == "Si" ? (
                                <div style={{ display: "flex", gap: 6 }}>
                                  {user.surtidos_create ? (
                                    <Button title="Surtir este pedido"
                                      color="success"
                                      size="sm"
                                      onClick={() => { setPedidoSurtir(a); setModalSurtir(true); }}
                                    >
                                      <i class="fas fa-truck-moving"></i>
                                    </Button>
                                  ) : undefined}
                                  <Button title="Editar el pedido: datos y artículos"
                                    color="info"
                                    id="Editar"
                                    size="sm"
                                    onClick={(e) =>
                                      EditArticulos(
                                        a._id,
                                        a.numero,
                                        a.comisionTDC,
                                        a.comisionFlete,
                                        a.impuestos,
                                        a.subTotal,
                                        a.iva,
                                        a.total_general,
                                        a.total_cantidad,
                                        a.surtido,
                                        a.clientes,
                                        a.idClientes,
                                        a.fechaModificado,
                                        a.fecha,
                                        a.descuento,
                                        {
                                          tipo: a.tipo,
                                          paqueteria: a.paqueteria,
                                          ordenCompraCliente: a.ordenCompraCliente,
                                          observaciones: a.observaciones,
                                        }
                                      )
                                    }
                                  >
                                    <i class="far fa-edit"></i>
                                  </Button>
                                  {user.menu_oc ? (
                                    <Button
                                      color="primary"
                                      id="GenerarOC"
                                      size="sm"
                                      title="Generar PO"
                                      href={`/GenerarOC/${a._id}`}
                                    >
                                      <i class="fas fa-file-import"></i>
                                    </Button>
                                  ) : undefined}
                                </div>
                              ) : undefined
                            ) : undefined}
                            </div>
                          </td>
                        </tr>
                      );
                    }
                  })}
                </tbody>
              </Table>
              <div className="col-md-6">
                <Pagination
                  total={totalItems}
                  itemsPerPage={ITEMS_PER_PAGE}
                  currentPage={currentPage}
                  onPageChange={(page) => setCurrentPage(page)}
                />
              </div>
            </>
          ) : (
            <EditarArticulosPedido
              pedido={pedidoEditar}
              articulos={articulos}
              coloresCat={coloresCat}
              tallasCat={tallasCat}
              user={user}
              onRegresar={() => setAbrirEditar(false)}
            />
          )}
        </div>
      ) : undefined}
      <br />

      <ImportarArticulosModal
        abierto={modalImportar}
        cerrar={() => setModalImportar(false)}
      />

      <DetalleDivididoModal
        abierto={!!prepedidoDetalle}
        cerrar={() => setPrepedidoDetalle(null)}
        prepedido={prepedidoDetalle}
      />

      <FotosPedidoModal
        abierto={!!pedidoFotos}
        cerrar={() => setPedidoFotos(null)}
        pedido={pedidoFotos}
      />

      <SurtirPedidoModal
        abierto={modalSurtir}
        cerrar={() => setModalSurtir(false)}
        pedido={pedidoSurtir}
        user={user.id}
        onSurtido={() => window.location.reload()}
      />

      <ImportarPrepedidoModal
        abierto={modalPrepedido}
        user={user}
        cerrar={() => setModalPrepedido(false)}
        onImportado={() => window.location.reload()}
      />

      <DividirPrepedidoModal
        abierto={modalDividir}
        cerrar={() => setModalDividir(false)}
        prepedido={prepedidoDividir}
        onDividido={() => window.location.reload()}
      />

      <Modal size="sm" isOpen={modalCambiaPrecio} toggle={toggleCambiaPrecio}>
        <ModalHeader toggle={toggleCambiaPrecio}>
          <h4>Autorizar Cambio de Precio</h4>
        </ModalHeader>
        <ModalBody>
          <Input
            bsSize="sm"
            type="password"
            placeholder="Password"
            value={password}
            required
            onChange={(event) => setPassword(event.target.value)}
          />
          <br />
          <Row>
            <Col>
              <Button
                type="submit"
                className="btn btn-success"
                onClick={(e) => autorizaCambio()}
              >
                Autorizar
              </Button>
            </Col>
          </Row>
        </ModalBody>
      </Modal>

      <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
        <ModalHeader toggle={toggleProgreso}>
          <h4>Progreso</h4>
        </ModalHeader>
        <ModalBody>
          <h4>
            {" "}
            Este proceso puede tardar varios segundos.
            <br />
            Por favor no cierre ni refresque su navegador.
          </h4>
          <br />
          <div className="progreso">
            <Spinner
              style={{
                width: "50px",
                height: "50px",
                color: "#232B41",
              }}
            />
            <Spinner
              style={{
                width: "50px",
                height: "50px",
                color: "#232B41",
              }}
            />
            <Spinner
              style={{
                width: "50px",
                height: "50px",
                color: "#232B41",
              }}
            />
          </div>
        </ModalBody>
      </Modal>

      <Modal size="sm" isOpen={modalNoDisponible} toggle={toggleNoDisponible}>
        <ModalHeader toggle={toggleNoDisponible}>
          <h4>No hay Inventario Disponible</h4>
        </ModalHeader>
        <ModalBody>
          <Table size="sm" striped borderless className="table-responsive-xl">
            <tr>
              <th>Articulo</th>
              <th>Pedido</th>
              <th>Disponible</th>
            </tr>

            {allArticulosAutorizar.map((a) => {
              if (a.disponible < a.cantidadPedido) {
                return (
                  <tr style={{ backgroundColor: "#ed8c8c" }}>
                    <td>{a.articuloNombre}</td>
                    <td>
                      {new Intl.NumberFormat("en-US").format(a.cantidadPedido)}
                    </td>
                    <td>
                      {new Intl.NumberFormat("en-US").format(a.disponible)}
                    </td>
                  </tr>
                );
              } else {
                return (
                  <tr>
                    <td>{a.articuloNombre}</td>
                    <td>
                      {new Intl.NumberFormat("en-US").format(a.cantidadPedido)}
                    </td>
                    <td>
                      {new Intl.NumberFormat("en-US").format(a.disponible)}
                    </td>
                  </tr>
                );
              }
            })}
          </Table>
        </ModalBody>
      </Modal>

      {loader}
    </>
  );
}

export default ListadoPedidos;
